export default {
  state: {
    monitoringList: null,
    monitoringTotalCount: null,
    monitoringSingle: null,
    monitoringStatistics: null,
    monitoringStatisticsTotalCount: null,
    monitoringStatisticsRequestId: null
  },
  mutations: {
    setMonitoringList (state, payload) {
      state.monitoringList = []
      state.monitoringList = payload
    },
    setMonitoringTotalCount (state, payload) {
      state.monitoringTotalCount = payload
    },
    setMonitoringSingle (state, payload) {
      state.monitoringSingle = payload
    },
    setMonitoringStatistics (state, payload) {
      state.monitoringStatistics = payload
    },
    setMonitoringStatisticsTotalCount (state, payload) {
      state.monitoringStatisticsTotalCount = payload
    },
    setMonitoringStatisticsRequestId (state, payload) {
      state.monitoringStatisticsRequestId = payload
    }
  },
  actions: {
    async getMonitoringList ({commit, dispatch}, {mode, offset, limit}) {
      const url = '/admin/monitoring/list?access_token=' + this.getters.accessToken + '&mode=' + mode + '&offset=' + offset + '&limit=' + limit
      await dispatch('apiGet', url)
        .then((data) => {
          commit('setMonitoringList', data.monitoring_list)
          commit('setMonitoringTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getMonitoringSingle ({commit, dispatch}, {id}) {
      const url = '/admin/monitoring/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setMonitoringSingle', data.monitoring)
        })
        .catch((error) => {
          throw error
        })
    },
    async deleteMonitoring ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }
      post.url = '/admin/monitoring/' + id + '/remove?access_token=' + this.getters.accessToken
      await dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Мониторинг удалена успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    async createMonitoring ({commit, dispatch}, monitoringData) {
      let postData = new FormData()

      postData.append('title', monitoringData.title)
      postData.append('start_date', monitoringData.startDate)
      postData.append('end_date', monitoringData.endDate)
      postData.append('frequency', monitoringData.frequency)
      postData.append('max_checks', monitoringData.max_checks)
      postData.append('is_required', monitoringData.isRequired)

      if (typeof monitoringData.pointFolderIdList !== 'undefined') {
        postData.append('point_folder_id_list', monitoringData.pointFolderIdList)
      }
      if (typeof monitoringData.pointIdList !== 'undefined') {
        postData.append('point_id_list', monitoringData.pointIdList)
      }
      if (typeof monitoringData.productXls !== 'undefined') {
        postData.append('product_xls', monitoringData.productXls)
      }
      if (typeof monitoringData.channelIdList !== 'undefined') {
        postData.append('distribution_channel_id_list', monitoringData.channelIdList)
      }

      let post = {}

      let returnData = null
      if (monitoringData.id === null) {
        post.url = '/admin/monitoring/add?access_token=' + this.getters.accessToken
        post.data = postData
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Мониторинг создан успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        postData.append('id', monitoringData.id)

        post.url = '/admin/monitoring/' + monitoringData.id + '/update?access_token=' + this.getters.accessToken
        post.data = postData

        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Мониторинг изменен успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    },
    getMonitoringStatistics ({commit, dispatch, state}, {id, q, branchId, limit, offset}) {
      let urlQ = ''
      if (q !== null && typeof q !== 'undefined') {
        urlQ = '&q=' + q
      }

      let urlBranchId = ''
      if (branchId !== null && typeof branchId !== 'undefined') {
        urlBranchId = '&branch_id=' + branchId
      }

      let urlOffset = ''
      if (offset !== null && typeof offset !== 'undefined') {
        urlOffset = '&offset=' + offset
      }

      let urlLimit = ''
      if (limit !== null && typeof limit !== 'undefined') {
        urlLimit = '&limit=' + limit
      }

      const url = '/admin/monitoring/' + id + '/statistics/list?access_token=' + this.getters.accessToken + urlQ + urlBranchId + urlLimit + urlOffset
      let requestId = setTimeout(function () {
        dispatch('apiGet', url)
          .then((data) => {
            if (requestId === state.monitoringStatisticsRequestId) {
              console.log(data)
              commit('setMonitoringStatistics', data.monitoring_statistics_list)
              commit('setMonitoringStatisticsTotalCount', data.total_count)
            }
          })
          .catch((error) => {
            throw error
          })
      }, 100)
      commit('setMonitoringStatisticsRequestId', requestId)
    }
  },
  getters: {
    monitoringList (state) {
      return state.monitoringList
    },
    monitoringTotalCount (state) {
      return state.monitoringTotalCount
    },
    monitoringSingle (state) {
      return state.monitoringSingle
    },
    monitoringStatistics (state) {
      return state.monitoringStatistics
    },
    monitoringStatisticsTotalCount (state) {
      return state.monitoringStatisticsTotalCount
    },
    monitoringStatisticsRequestId (state) {
      return state.monitoringStatisticsRequestId
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/monitoring.js